module.exports = __webpack_public_path__ + "static/media/104walkCycle.16ea412e.gif";